export default __webpack_public_path__ + "static/media/Sur_mesure_Nature.3d9b8575.jpg";